export const FILL_ORDERS = 'FILL_ORDERS'
export const TOGGLE_SIDEBAR = 'TOOGLE_SIDEBAR'
export const SET_SELECTED_ORDERS = 'SET_SELECTED_ORDERS'
